var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAppGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_673_1994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_673_1994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.262 47.0533C61.262 47.4275 61.1684 47.7704 61.0125 48.051C60.6383 48.7058 59.9524 49.1424 59.1417 49.1424C57.9569 49.1424 57.0215 48.207 57.0215 47.0221C57.0215 45.8373 57.9569 44.9019 59.1417 44.9019C59.9524 44.9019 60.6383 45.3384 61.0125 45.9932C61.1684 46.3674 61.262 46.7104 61.262 47.0533Z",
    fill: "#D8A777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0535 33.7082H64.1938V21.735C64.1938 18.0245 61.1694 15 57.4589 15H31.7351C28.0246 15 25 18.0245 25 21.735V78.2649C25 81.9754 28.0246 85 31.7351 85H57.4589C61.1694 85 64.1938 81.9754 64.1938 78.2649V60.461H71.0535C72.9555 60.461 74.4833 58.9331 74.4833 57.0311V37.1692C74.4833 35.236 72.9555 33.7082 71.0535 33.7082ZM57.4589 81.8195H31.7351C30.0513 81.8195 28.6169 80.6346 28.2739 79.0444H60.9511C60.5769 80.6035 59.1426 81.8195 57.4589 81.8195ZM61.0133 75.833H28.1492V21.7038C28.1492 19.7394 29.7395 18.1492 31.7039 18.1492H57.4277C59.392 18.1492 60.9823 19.7394 60.9823 21.7038V33.677H47.2004C45.2984 33.677 43.7707 35.2049 43.7707 37.1069V56.9688C43.7707 58.8708 45.2984 60.3986 47.2004 60.3986H48.3541V64.8574C48.3541 65.2939 48.6348 65.6993 49.0401 65.8552C49.1649 65.9176 49.3208 65.9487 49.4455 65.9487C49.7261 65.9487 50.0068 65.824 50.225 65.6369L55.4321 60.4297H60.9823V75.833H61.0133ZM72.3006 57C72.3006 57.686 71.7395 58.2472 71.0535 58.2472H55.0267C54.7461 58.2472 54.4655 58.3719 54.2472 58.559L50.5992 62.2071V59.3385C50.5992 58.7461 50.1002 58.2472 49.5077 58.2472H47.2628C46.5769 58.2472 46.0155 57.686 46.0155 57V37.138C46.0155 36.452 46.5769 35.8908 47.2628 35.8908H71.0847C71.7707 35.8908 72.3318 36.452 72.3318 37.138V57H72.3006Z",
    fill: "#D8A777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1587 23.294C51.1587 24.1671 50.4416 24.8842 49.5685 24.8842H39.622C38.7489 24.8842 38.0317 24.1671 38.0317 23.294C38.0317 22.421 38.7489 21.7038 39.622 21.7038H49.5685C50.4416 21.7038 51.1587 22.421 51.1587 23.294Z",
    fill: "#D8A777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2531 49.1736C52.424 49.1736 53.3735 48.2244 53.3735 47.0534C53.3735 45.8824 52.424 44.933 51.2531 44.933C50.0821 44.933 49.1328 45.8824 49.1328 47.0534C49.1328 48.2244 50.0821 49.1736 51.2531 49.1736Z",
    fill: "#D8A777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0286 49.1736C68.1996 49.1736 69.1489 48.2244 69.1489 47.0534C69.1489 45.8824 68.1996 44.933 67.0286 44.933C65.8576 44.933 64.9082 45.8824 64.9082 47.0534C64.9082 48.2244 65.8576 49.1736 67.0286 49.1736Z",
    fill: "#D8A777"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppGold);
export default __webpack_public_path__ + "static/media/icon_app_gold.1a55628cbe61f6896a44c7ce11e065c3.svg";
export { ForwardRef as ReactComponent };